import React from "react";

import UserControls from "./UserControls";
import {
  usePageHeaderActions,
  usePageHeaderTitle,
} from "../hooks/PageHeaderContext";
import { useMobileAvatarHidden } from "../hooks/MobileUserSlotContext";

// No header bar on mobile, ever: the top scroll edge frosts and the user button
// floats top-right (unless a list page's search row already hosts it). Desktop
// keeps a header bar carrying the page title + page actions (the sidebar owns
// the profile there).
const AppHeader = () => {
  const title = usePageHeaderTitle();
  const actions = usePageHeaderActions();
  const userSlotClaimed = useMobileAvatarHidden();

  const showDesktopBar = !!title || !!actions;

  return (
    <>
      {/* Desktop-only header bar: page title + page actions. */}
      {showDesktopBar && (
        <header className="tw:sticky tw:top-0 tw:z-40 tw:glass tw:border-0! tw:border-b! tw:border-glassborder! tw:shadow-none! tw:rounded-none! tw:hidden tw:lg:block">
          {/* One deterministic 64px row: title left, actions right. Keeping it a
              single fixed-height row (not a title row + a wrapped actions row)
              means in-content sticky elements can pin just below it with a single
              known offset. text-lg! beats Bootstrap's unlayered h1 font-size. */}
          <div className="tw:flex tw:h-16 tw:items-center tw:gap-4 tw:px-6">
            <h1 className="tw:my-0! tw:flex tw:min-w-0 tw:items-center tw:gap-2 tw:truncate tw:text-xl! tw:font-semibold tw:tracking-tight tw:leading-none tw:text-text">
              {title}
            </h1>
            {actions && (
              <div className="tw:ml-auto tw:flex tw:shrink-0 tw:items-center tw:gap-2">
                {actions}
              </div>
            )}
          </div>
        </header>
      )}

      {/* Mobile: frost the top scroll edge (no header to slide under). */}
      <div className="tw:pointer-events-none tw:fixed tw:inset-x-0 tw:top-0 tw:z-10 tw:h-28 tw:edge-blur-top tw:lg:hidden" />

      {/* Mobile: floating user button, top-LEFT — the same spot a list page's
          search row puts it (the row hosts it there instead, to avoid a
          duplicate). Keeping it left in both cases means the user button sits in
          the same place across every view. left-4 aligns with the content gutter
          (CContainer px-4). */}
      {!userSlotClaimed && (
        <div className="tw:fixed tw:left-4 tw:top-2 tw:z-40 tw:lg:hidden">
          <UserControls showName={false} />
        </div>
      )}
    </>
  );
};

export default AppHeader;
